import { documentationFeatureFlag } from '../../documentation/featureFlag';

// Route items
export const summary = () => ({
  key: 'summary',
  to: '/summary',
  name: 'Summary',
  icon: 'summary'
});

export const analytics = () => ({
  key: 'analytics',
  to: '#',
  name: 'Analytics',
  icon: 'analytics',
  // userType: 'BRAND',
  subitems: [
    {
      key: 'charts',
      to: '/charts',
      name: 'Charts',
      icon: 'chartsOutline'
    },
    {
      key: 'insights',
      to: '/insights',
      name: 'Insights',
      icon: 'insights'
    },
    {
      key: 'discovery',
      to: '/discovery',
      name: 'Discovery',
      icon: 'discovery',
      isMobileOnly: true
    }
  ]
});

export const brandCharts = () => ({
  key: 'brand_charts',
  to: '#',
  name: 'Analytics',
  icon: 'analytics',
  userType: 'BRAND',
  subitems: [
    {
      key: 'charts',
      to: '/charts',
      name: 'Charts',
      icon: 'chartsOutline',
      userType: 'BRAND'
    }
  ]
});

export const brandFeatures = () => ({
  key: 'features',
  to: '/attributioncharts',
  name: 'Attribution',
  icon: 'waypoints',
  userType: 'BRAND'
});

export const brandManagement = () => ({
  key: 'brand_management',
  to: '#',
  name: 'Management',
  icon: 'settings',
  userType: 'BRAND',
  subitems: [
    {
      key: 'webembed',
      to: '/webembed',
      name: 'Web Embed',
      icon: 'webAnalytics',
      userType: 'BRAND',
      requiredPortalFeature: 'WEB_ANALYTICS'
    },
    {
      key: 'screen_to_store',
      to: '/screentostore',
      name: 'Screen to Store',
      icon: 'store',
      userType: 'BRAND',
      requiredPortalFeature: 'SCREEN_TO_STORE'
    }
  ]
});

export const campaigns = () => ({
  key: 'brand',
  to: '#',
  name: 'Brand',
  icon: 'tag',
  subitems: [
    { key: 'portals', to: '/portals', name: 'Portals', icon: 'summary' },
    { key: 'campaigns', to: '/campaigns', name: 'Campaigns', icon: 'campaigns' },
    { key: 'pos_integrations', to: '/pos', name: 'Point Of Sale', icon: 'connection' }
  ]
});

export const management = () => {
  const subitems = [
    {
      key: 'sites',
      to: '/sites',
      name: 'Sites',
      icon: 'location'
      // featureEnabled: 'dashboard-site-creation'
    },
    {
      key: 'devices',
      to: '/devices',
      name: 'Devices',
      icon: 'deviceOutlineDark'
    },
    {
      key: 'reports',
      to: '/reports',
      name: 'Reports',
      icon: 'reportOutlineDark'
    },
    {
      key: 'integrations',
      to: '/integrations',
      name: 'Integrations',
      icon: 'integrations'
    },
    {
      key: 'site_groups',
      to: '/sitegroups',
      name: 'Site Groups',
      icon: 'projectDarkOutline'
      //TODO: REMOVE COMMENT BEFORE DEPLOY TO PRODUCTION
    }
  ];

  return {
    key: 'management',
    to: '#',
    name: 'Management',
    icon: 'settings',
    subitems
  };
};

export const advanced = () => {
  const subitems = [
    {
      key: 'config',
      to: '/advanced',
      name: 'Devices',
      icon: 'deviceOutlineDark',
      isAdminOnly: true
    },
    {
      key: 'presets',
      to: '/presets',
      name: 'Presets',
      icon: 'preset',
      isAdminOnly: true
    }
  ];

  return {
    key: 'advanced',
    to: '#',
    name: 'Advanced',
    icon: 'advancedSettings',
    isAdminOnly: true,
    subitems
  };
};

export const documentation = () => ({
  key: 'documentation',
  to: '/documentation',
  name: 'Documentation',
  icon: 'book',
  featureEnabled: documentationFeatureFlag,
  isUniversal: true,
  stickToBottom: true
});
